import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => {
    const isLight = theme.palette.mode === 'light';

    return {
    wrapper: {
        padding: theme.spacing(2, 2.5),
        borderRadius: theme.shape.borderRadius * 2,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1.5),
    },
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    badge: {
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
        borderRadius: 20,
        padding: '2px 10px',
        fontSize: 12,
        fontWeight: 700,
        lineHeight: '20px',
    },
    verTodas: {
        color: theme.palette.primary.main,
        fontWeight: 600,
        fontSize: 13,
        cursor: 'pointer',
        '&:hover': { textDecoration: 'underline' },
    },
    dayTabs: {
        display: 'flex',
        gap: theme.spacing(0.75),
        overflowX: 'auto',
        marginBottom: theme.spacing(2),
        paddingBottom: 2,
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
        gap: theme.spacing(2),
        width: '100%',
    },
    card: {
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius * 2,
        backgroundColor: isLight ? '#FFFFFF' : '#1e1e2e',
        color: isLight ? theme.palette.text.primary : '#fff',
        border: isLight ? '1px solid rgba(0,0,0,0.23)' : 'none',
        height: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
    },
    cardFeatured: {
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
        border: 'none',
    },
    validDaysLabel: {
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: 1.2,
        color: isLight ? 'rgba(0,0,0,0.45)' : 'rgba(255,255,255,0.55)',
        textTransform: 'uppercase',
        marginBottom: theme.spacing(0.25),
    },
    validDaysLabelFeatured: {
        color: 'rgba(255,255,255,0.7)',
    },
    entity: {
        fontWeight: 700,
        fontSize: 17,
        color: isLight ? theme.palette.text.primary : '#fff',
        lineHeight: 1.2,
    },
    entityFeatured: {
        color: '#fff',
    },
    mainText: {
        color: isLight ? theme.palette.text.secondary : 'rgba(255,255,255,0.8)',
        fontSize: 13,
    },
    mainTextFeatured: {
        color: 'rgba(255,255,255,0.85)',
    },
    secondaryText: {
        fontWeight: 700,
        fontSize: 16,
        color: theme.palette.primary.main,
        lineHeight: 1.2,
    },
    secondaryTextFeatured: {
        color: '#fff',
    },
    dateRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        marginTop: 'auto',
        paddingTop: theme.spacing(1),
        color: isLight ? theme.palette.text.secondary : 'rgba(255,255,255,0.45)',
        fontSize: 11,
    },
    dateRowFeatured: {
        color: 'rgba(255,255,255,0.75)',
    },
    dateIcon: {
        fontSize: 12,
        color: isLight ? theme.palette.text.secondary : 'rgba(255,255,255,0.45)',
    },
    dateIconFeatured: {
        color: 'rgba(255,255,255,0.75)',
    },
    legalText: {
        fontSize: 10,
        color: isLight ? theme.palette.text.disabled : 'rgba(255,255,255,0.35)',
        marginTop: theme.spacing(0.5),
    },
    legalTextFeatured: {
        color: 'rgba(255,255,255,0.6)',
    },
    paymentMethodsRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(0.5),
        marginTop: theme.spacing(0.75),
    },
    paymentBadge: {
        fontSize: 10,
        fontWeight: 700,
        color: '#fff',
        borderRadius: 4,
        padding: '2px 8px',
        letterSpacing: 0.3,
    },
    emptyText: {
        color: theme.palette.text.secondary,
        fontSize: 13,
    },
    };
});

export default useStyles;
